import { ManifestClientService } from './manifest-client.service';

class AnalyticsServiceController {
  constructor() {}

  async identifyUser() {
    const manifest = await ManifestClientService.getManifest();
    (window as any).analytics.identify(`${manifest.user.email} (${manifest.user._id}) ${manifest.company.name}`, {
      companyCountry: manifest.company.country,
      companyCreationDate: new Date(manifest.company.created),
      companyId: manifest.company._id,
      email: manifest.user.email,
      entitlements: this.formatEntitlements(manifest),
      firstName: manifest.user.firstName,
      lastName: manifest.user.lastName,
      userId: manifest.user._id,
      userRole: manifest.user.role,
      userTimezone: manifest.user.timezone,
      userType: manifest.user.isInternal ? 'Internal': 'External'
    })
  }

  formatEntitlements(manifest) {
    const formattedEntitlements = {};
    Object.keys(manifest.entitlements.v6).forEach(key => {
      formattedEntitlements[key] = manifest.entitlements.v6[key].value;
    });

    return formattedEntitlements;
  }
}

export const AnalyticsService = new AnalyticsServiceController();
